import React from 'react';
import PropTypes from 'prop-types';
import { Divider } from '@material-ui/core';
import { Flex } from '@knockrentals/knock-shared-web-v2';
import TabSectionHeader from './TabSectionHeader';
import { makeCss } from '../../../../../../knock-design-system';

export const LABEL_POSITIONS = {
  LEFT: 'left',
  TOP: 'top',
};

const useCss = makeCss({
  wrapper: {
    marginTop: '24px',
  },
});

const TabSection = ({
  children,
  description,
  isDividerHidden,
  labelPosition = LABEL_POSITIONS.TOP,
  title,
}) => {
  const css = useCss();

  const flexDirection =
    labelPosition === LABEL_POSITIONS.LEFT ? 'row' : 'column';

  const justifyContent =
    flexDirection === 'row' ? 'space-between' : 'flex-start';

  return (
    <div css={css.wrapper}>
      <Flex
        flexDirection={flexDirection}
        gap={24}
        justifyContent={justifyContent}
        mb={'24px'}
      >
        <TabSectionHeader description={description} title={title} />
        {children}
      </Flex>
      {!isDividerHidden && <Divider />}
    </div>
  );
};

TabSection.propTypes = {
  children: PropTypes.node,
  description: PropTypes.string,
  isDividerHidden: PropTypes.bool,
  labelPosition: PropTypes.oneOf([LABEL_POSITIONS.LEFT, LABEL_POSITIONS.TOP]),
  title: PropTypes.string,
};

export default TabSection;
